import { render, staticRenderFns } from "./ServiceBlocker.vue?vue&type=template&id=15953958&scoped=true&"
import script from "./ServiceBlocker.vue?vue&type=script&lang=js&"
export * from "./ServiceBlocker.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBlocker.vue?vue&type=style&index=0&id=15953958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15953958",
  null
  
)

export default component.exports